// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eN4r7LXXuqOsR6-KP8RysA\\=\\= input{margin:0 !important;padding:23px !important}.container-whitelabel-svb{padding-left:0 !important}", "",{"version":3,"sources":["webpack://client_react/src/components/Login/LoginPage.styl"],"names":[],"mappings":"AACE,kCACE,mBAAQ,CACR,uBAAS,CAIb,0BACE,yBAAc","sourcesContent":[":local(.global) {\n  input {\n    margin: 0 !important;\n    padding: 23px !important;\n  }\n}\n\n.container-whitelabel-svb {\n  padding-left: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "eN4r7LXXuqOsR6-KP8RysA=="
};
module.exports = ___CSS_LOADER_EXPORT___;
